import "./home.scss";
import { init } from 'ityped';
import {useEffect, useRef} from "react";
import Button from "../button/Button";
import ButtonSelect from "../buttonSelect/ButtonSelect";

export default function Home(){

    const textRef = useRef();

    useEffect(()=>{
        init(textRef.current,
            { showCursor: true,
                backSpeed: 100,
                backDelay:  1000,
                strings: ['Développeur Back-end', 'Développeur Front-end', 'Web Designer' ] })
    }, [])

    return (
        <div className="home" id="home">
            <div className={"left"}>
                <h2 className={"title-name"}>Pierre BIHANNIC</h2>
                <h3 className={"subtitle-name"}><span ref={textRef}/></h3>
                <span className={"divider"}/>
                <p className={"content-home"}>
                    Etudiant M2 MIAGE - MBDS.<br/>
                    Âgé de 22 ans, je suis passionné par l'informatique et par
                    le monde numérique.
                </p>
                <Button title={"Contactez moi"} link={"#contact"}/>
            </div>
            <div className={"right"}>
                <div className={"image-container"}>
                    <img src={"assets/background_home.svg"} />
                    <div className={"illustration-container"}>
                        <img src={"assets/illustration_cafe.svg"} className={"ill_coffee"}/>
                        <img src={"assets/illustration_ordinateur.svg"} className={"ill_computer"} />
                    </div>
                </div>
            </div>
        </div>
    )
}